export default __webpack_public_path__ + "static/Summer Illustration-5bb15373157e809543677f9c2dfb498f.png";